import { Options, Vue } from 'vue-class-component';
import { Inject, Watch } from 'vue-property-decorator';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import NavigationBar from '@/shared/components/navigation-bar/index.vue';
import { TrustAPI } from '@/shared/modules/trust-api';
import AddEditModal from './add-edit-modal/index.vue';
import AuditTrail from './audit-trail/index.vue';
import { InvestigationTypeView } from '@/shared/modules/typescript-trustapi-client/models';
import { AppInsights } from '@/trust-admin-app/appInsights';
import store from '@/trust-admin-app/store';
import { EventEmitter } from 'events';


// Vue.registerHooks(['beforeRouteEnter']);
@Options({
  components: {
    NavigationBar,
    AddEditModal,
    AuditTrail,
    LoadingIndicator,
    ErrorIndicator
  }
})
export default class TrustDataInvestigationTypes extends Vue {
  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private showActiveOnly = true;
  private showAddEditModal = false;
  private showAuditTrailModal = false;
  private loadingContent = true;
  private errorLoadingContent = false;
  private clickedEdit = false;
  private chosenInvestigationId = 0;
  private chosenInvestigationName = '';
  private searchKeyword = '';

  private investigationTypes: InvestigationTypeView[] = [];
  private investigationTypesTable: InvestigationTypeView[] = [];

  private chosenInvestigationType: InvestigationTypeView = {};

  private tableHeadings = [
    { text: 'Name', value: 'name', sortable: false },
    { text: 'Expected duration', value: 'expectedDuration', sortable: false },
    { text: 'Investigation Category', value: 'investigationCategory', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Actions', value: 'actions', sortable: false },
  ]

  mounted() {
    this.getInvestigationTypes();
  }

  @Watch('showActiveOnly')
  onShowActiveChanged() {
    this.getInvestigationTypes();
  }

  @Watch('searchKeyword')
  onSearchChanged() {
    this.investigationTypesTable = this.investigationTypes.filter(x => {
      return x.name.toLocaleLowerCase().includes(this.searchKeyword.toLocaleLowerCase())
    })
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }


  private getInvestigationTypes(): void {
    this.apiService.ConfigTrustApi?.apiV2ConfigTrustGetInvestigationTypesPost({}, false)
      .then(res => {
        this.loadingContent = false;
        this.errorLoadingContent = false;
        this.investigationTypes = res.data.data;

        if (this.showActiveOnly) {
          this.investigationTypesTable = this.investigationTypes.filter(x => {
            return x.status.name === "Active";
          })
        } else {
          this.investigationTypesTable = this.investigationTypes;
        }
      })
      .catch(error => {
        this.loadingContent = false;
        this.errorLoadingContent = true
        this.eventCtrl.emit('show-snackbar', 'error', error);
        this.ai.trackException('Error getting investigation types: ' + error);
      });
  }

  private openAdd(): void {
    this.clickedEdit = false;
    this.chosenInvestigationType = {
      name: '',
      expectedDuration: 0,
      status: { id: 1 },
      defaultInvestigationCategory: { id: 1 }
    }
    this.showAddEditModal = true;
  }

  private openEdit(t: InvestigationTypeView): void {
    this.chosenInvestigationType.status = {};
    this.clickedEdit = true;
    this.chosenInvestigationType = { ...t };
    this.showAddEditModal = true;
  }

  private openAuditTrail(investigationName: string, investigationId: number): void {
    this.chosenInvestigationName = investigationName;
    this.chosenInvestigationId = investigationId;
    this.showAuditTrailModal = true;
  }
}